import * as model from 'BASE/store/chat/chat.store.model';

class ChatTransformServerName {
    constructor() {}

    transformRoom(input) {
        return new model.room({
            id: input.RoomId,
            type: input.Type,
            name: input.Name,
            unreadCount: input.UnreadCount,
            isReadOnly: input.IsReadOnly,
            announcement: input.Announcement,
            messageClearTime: new Date(input.MessageClearTime),
            groupReadOnly: input.GroupReadOnly,
            image: input.Image,
            description: input.Description,
            hasPassword: input.HasPassword,
        });
    }

    transformRoomMember(input) {
        return new model.roomMember({
            userId: input.HashUserId,
            loginId: input.LoginId,
            nickName: input.NickName,
            role: input.Role,
            isOnline: input.IsOnline,
            isChatDenied: input.IsChatDenied,
            userLevel: input.UserLevel,
            headImage: input.HeadImage,
            isReadOnly: input.IsReadOnly,
        });
    }

    transformRoomMessage(input) {
        return {
            roomId: input.RoomId,
            userId: input.UserId,
            messageId: input.MessageId,
            type: input.Type,
            content: input.Content,
            name: input.Name,
            timestamp: input.Timestamp,
            headImage: input.HeadImage,
            userLevel: input.UserLevel,
        };
    }
}

export default new ChatTransformServerName();
